import { useState, useEffect } from "react";
import { AdminField, AdminSaveButton, AdminSection } from "@/admin/AdminComponents";
import { Plus, Trash2 } from "lucide-react";

const NavbarEditor = ({ data, onSave, saving }) => {
  const [form, setForm] = useState({});

  useEffect(() => { setForm({ ...data }); }, [data]);

  const update = (key, val) => setForm((p) => ({ ...p, [key]: val }));
  const updateLink = (idx, key, val) => {
    const links = [...(form.links || [])];
    links[idx] = { ...links[idx], [key]: val };
    setForm((p) => ({ ...p, links }));
  };
  const removeLink = (idx) => {
    const links = [...(form.links || [])];
    links.splice(idx, 1);
    setForm((p) => ({ ...p, links }));
  };
  const addLink = () => {
    const links = [...(form.links || [])];
    links.push({ label: "", href: "#" });
    setForm((p) => ({ ...p, links }));
  };

  return (
    <div data-testid="navbar-editor">
      <AdminSection title="Navbar" description="Navigation bar settings">
        <AdminField label="Logo Text (fallback)" value={form.logo} onChange={(v) => update("logo", v)} />
        <div className="grid grid-cols-2 gap-4">
          <AdminField label="Contact Button Text" value={form.contact_text} onChange={(v) => update("contact_text", v)} />
          <AdminField label="Contact Email" value={form.contact_email} onChange={(v) => update("contact_email", v)} type="email" />
        </div>
      </AdminSection>

      <AdminSection title="Navigation Links">
        {(form.links || []).map((link, idx) => (
          <div key={idx} className="flex items-end gap-3">
            <div className="flex-1 grid grid-cols-2 gap-3">
              <AdminField label={`Label ${idx + 1}`} value={link.label} onChange={(v) => updateLink(idx, "label", v)} />
              <AdminField label="Anchor" value={link.href} onChange={(v) => updateLink(idx, "href", v)} placeholder="#section" />
            </div>
            <button onClick={() => removeLink(idx)} className="p-2 mb-1 rounded-md text-neutral-600 hover:text-red-400 hover:bg-red-500/10 transition-colors">
              <Trash2 className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
        <button
          data-testid="add-nav-link"
          onClick={addLink}
          className="w-full flex items-center justify-center gap-2 py-3 rounded-xl border border-dashed border-white/[0.1] text-sm text-neutral-500 font-['Manrope'] hover:border-white/[0.2] hover:text-white transition-colors duration-200"
        >
          <Plus className="w-4 h-4" /> Add Link
        </button>
      </AdminSection>

      <AdminSaveButton onClick={() => onSave(form)} saving={saving} />
    </div>
  );
};

export default NavbarEditor;
